export const userConstants = {
 
    // LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    // LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    // LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
 
    LOGOUT: 'USERS_LOGOUT',
    LOGOUT_SUCCESS: 'USERS_LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'USERS_LOGOUT_FAILURE',
 
    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    GET_USER_REQUEST: 'USER_GET_REQUEST',
    GET_USER_SUCCESS: 'USER_GET_SUCCESS',
    GET_USER_FAILURE: 'USER_GET_FAILURE',

    FORGOTPWD_REQUEST: 'FORGOTPWD_REQUEST',
    FORGOTPWD_SUCCESS: 'FORGOTPWD_SUCCESS',
    FORGOTPWD_FAILURE: 'FORGOTPWD_FAILURE',

    GET_USERLOGIN_BYTOKEN_REQUEST:'GET_USERLOGIN_BYTOKEN_REQUEST',
    GET_USERLOGIN_BYTOKEN_SUCCESS:'GET_USERLOGIN_BYTOKEN_SUCCESS',
    GET_USERLOGIN_BYTOKEN_FAILURE: 'GET_USERLOGIN_BYTOKEN_FAILURE',

    ResetPasssword_REQUEST:'ResetPasssword_REQUEST',
    ResetPasssword_SUCCESS:'ResetPasssword_SUCCESS',
    ResetPasssword_FAILURE: 'ResetPasssword_FAILURE'
 
   
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/userConstants.js